<template>
  <div>
    <van-nav-bar
      title="新增门店备货单"
      :left-text="'您好，' + userInfo.emp_name"
    />
    <van-form ref="form" validate-first @failed="toast('请完善订单信息')">
      <van-tabs v-model="active">
        <van-tab title="产品信息">
          <br>
          <van-col :span="8" style="text-align: left; padding-left: 10px;">
            <base-button @click="add">新增</base-button>
          </van-col>
          <van-col :span="24" v-for="(detail, index) in form.details" :key="detail.key">
            <van-swipe-cell>
              <van-card :num="detail.count" :price="detail.price" :desc="detail.name" :title="'产品' + (index + 1)"
                        thumb="https://img.yzcdn.cn/vant/ipad.jpeg" @click="onSelectGoods(detail)">
                <div slot="tags">
                  <van-tag plain type="danger" v-if="detail.type">{{ detail.type }}</van-tag>
                  <van-tag plain type="primary" v-if="detail.specs">{{ detail.specs }}</van-tag>
                </div>
                <div slot="footer">
                  <van-col :span="4">
                    <base-button type="danger" size="mini" @click="del(detail)">删除</base-button>
                  </van-col>
                  <van-col :span="4">
                    <base-button type="info" size="mini" @click="showDetails(detail)">详情</base-button>
                  </van-col>
                  <van-col :span="2" :offset="8">
                    <van-icon name="clear" @click.stop="onCountChange(detail, 'reduce')"
                              color="#ff4949" size="20" />
                  </van-col>
                  <van-col :span="2">
                    <van-icon name="add" @click.stop="onCountChange(detail, 'increase')"
                              color="#07c160" size="20" />
                  </van-col>
                </div>
              </van-card>
              <van-col :span="12">
                <base-input-number v-model="detail.count" label="数量"
                                   @change="onCountOrDiscountChange(detail, true)" />
              </van-col>
              <van-col :span="12">
                <base-input-number v-model="detail.amount" label="小计"
                                   @change="onAmountChange(detail)" />
              </van-col>
              <van-col :span="24">
                <base-textarea v-model="detail.remark" label="特殊要求" />
              </van-col>
              <base-button slot="right" type="danger" size="mini" class="delete-button"
                           @click="del(detail)">删除</base-button>
            </van-swipe-cell>
          </van-col>
          <van-popup v-model="showSearchList" :style="{ height: '80%' }" position="bottom">
            <base-search-goods-list @change="onConfirmOfSelectGoods" />
          </van-popup>
        </van-tab>
        <van-tab title="其他信息">
          <van-col :span="20">
            <base-input v-model="form.code" label="订单号" readonly />
          </van-col>
          <van-col :span="4" style="margin-top: 10px;">
            <order-code :type="type" @getCode="form.code = $event" />
          </van-col>
          <base-datetime v-model="form.delivery_time" label="送货时间" required />
          <base-textarea v-model="form.remark" label="备注" />
          <base-input v-model="form.receiver" label="收货人" />
          <base-input v-model="form.receiver_phone" label="收货人电话" />
          <base-textarea v-model="form.receiver_addr" label="收货人地址" />
          <van-col :span="24" v-if="userInfo.source_ids">
            <base-select v-model="form.orderer_id" label="订单来源" :options="form.ordererList"
                         @change="onConfirmOfSelectOrderer" />
          </van-col>
          <van-col :span="24" @click="showSearchListOfClient = true" v-else>
            <base-input v-model="form.orderer" label="订单来源" required readonly />
          </van-col>
          <van-popup v-model="showSearchListOfClient" :style="{ height: '60%' }" position="bottom">
            <base-search-client-list @change="onConfirmOfSelectClient" />
          </van-popup>
        </van-tab>
      </van-tabs>
        <van-submit-bar :loading="saveLoading" :price="form.total_amount * 100"
                        label="合计：" button-text="提交" @submit="save" :safe-area-inset-bottom="true">
          <span slot="tip">
            总数量：{{ form.total_count | toThousandFilter }}
          </span>
        </van-submit-bar>
    </van-form>

    <init :init-states="initStates" @after-init="init" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Init from '@/components/base/init'
import OrderCode from '@/components/base/order-code'
import { getOrderCode } from '@/api/commons'
import { addRequireOrder, modifyRequireOrder } from '@/api/require/order'
export default {
  name: 'RequireOrder',
  components: { Init, OrderCode },
  data () {
    return {
      loading: false,
      saveLoading: false,
      active: 0,
      showSearchList: false,
      showSearchListOfClient: false,
      type: this.CONST.ORDER_BILL_TYPES.find(type => type.name === '门店备货单').id,

      selectedRow: null,

      formModel: {},
      form: {
        code: '',
        order_date: '',
        orderer_id: null,
        orderer: '',
        ordererList: [],
        details: [],
        delivery_time: '',
        remark: '',
        receiver: '',
        receiver_phone: '',
        receiver_addr: '',
        total_count: 0, // 总数量
        total_amount: 0 // 总金额（原值）
      },
      newRowOfGoods: {
        key: 0,
        name: '',
        type: '',
        code: '',
        selectedGoods: null,
        goods_id: null,
        goodsIdsArray: [],
        specs: '',
        count: 1,
        price: 0,
        amount: 0,
        remark: ''
      },
      initStates: [{
        key: 'goods/init'
      }]
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'goodsMapOfIdsArray', 'goodsMapOfId'])
  },
  methods: {
    init() {
      this.loading = true
      this.loadForm()
    },
    queryOrderCode(type) {
      getOrderCode({
        type: type
      }).then(resp => {
        this.form.code = resp.obj || ''
      })
    },
    calcTotalCountAndAmount() {
      let total_count = 0
      let total_amount = 0
      if (this.form.details && this.form.details.length > 0) {
        this.form.details.forEach(row => {
          total_count = parseFloat((total_count + parseFloat(row.count || 0))
            .toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
          total_amount = parseFloat((total_amount + parseFloat(row.count || 0) * (row.price || 0))
            .toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
        })
      }
      this.form.total_count = total_count
      this.form.total_amount = total_amount
    },
    validData() {
      let count = 0
      for (let i = 0, j = this.form.details.length; i < j; i++) {
        const row = this.form.details[i]
        if (row.goods_id) {
          if (!row.count) {
            this.error(`第 ${i + 1} 行数量不能为空`)
            return false
          }
          count++
        }
      }
      if (count > 0) {
        return true
      } else {
        this.error('单据明细不能为空，请您至少添加一条记录')
        return false
      }
    },
    save() {
      this.$refs['form'].validate().then(_ => {
        if (this.validData()) {
          this.saveLoading = true
          this.form.total_amount = this.form.total_amount || 0
          const data = this._.cloneDeep(this.form)
          data.details = []
          this.form.details.forEach(detail => {
            if (detail.goods_id) {
              data.details.push(this._.cloneDeep(detail))
            }
          })
          this.confirm('确定保存订单吗？').then(() => {
            if (data.id > 0) {
              modifyRequireOrder(data).then(resp => {
                this.success(resp.msg)
              })
            } else {
              addRequireOrder(data).then(resp => {
                this.success(resp.msg)
                this.confirm('是否清空表单？').then(() => {
                  this.resetForm()
                }).catch(() => {
                  this.queryOrderCode(this.type)
                })
              })
            }
          }).catch(_ => {})
        } else {
          toast('请完善订单信息')
        }
        this.saveLoading = false
      }).catch(error => {})
    },
    onConfirmOfSelectGoods(goods) {
      this.selectedRow.name = goods.name
      this.selectedRow.type = goods.type_names
      this.selectedRow.goodsIdsArray = this.goodsMapOfIdsArray[goods.id]
      this.selectedRow.goods_id = goods.id
      this.selectedRow.selectedGoods = goods
      this.selectedRow.code = goods.code
      this.selectedRow.price = goods.base_price
      this.selectedRow.specs = goods.specs
      this.selectedRow.tag = false
      this.onCountOrDiscountChange(this.selectedRow, true)
      this.showSearchList = false
    },
    onConfirmOfSelectOrderer(orderer_id, ordererList) {
      this.form.orderer = ''
      if (ordererList && ordererList.length > 0) {
        this.form.orderer = ordererList.find(orderer => orderer.id === orderer_id).name
      }
    },
    onConfirmOfSelectClient(client) {
      this.form.orderer = client.name
      this.form.orderer_id = client.id
      this.showSearchListOfClient = false
    },
    onCountOrDiscountChange(row, calcTotal) {
      if (row.tag) {
        row.tag = false
      } else {
        row.amount = parseFloat((parseFloat(row.count || 0) * parseFloat(row.price || 0))
          .toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
        if (calcTotal) {
          this.calcTotalCountAndAmount()
        }
      }
    },
    onAmountChange(row) {
      row.tag = true
      if (!row.count) {
        row.count = 1
      }
      this.calcTotalCountAndAmount()
    },
    onCountChange(detail, type) {
      if (type === 'increase') {
        detail.count++
      } else if (type === 'reduce') {
        detail.count > 1 ? detail.count-- : detail.count
      }
      this.onCountOrDiscountChange(detail, true)
    },
    onSelectGoods(row) {
      this.selectedRow = row
      this.showSearchList = true
    },
    resetForm(isModify) {
      this.Utils.resetValue(this.form)
      this.form.ordererList = []
      const sourceIdList = this.userInfo.source_ids ?
        this.userInfo.source_ids.split(',') : []
      const sourceNameList = this.userInfo.source_names ?
        this.userInfo.source_names.split(',') : []
      for (let i = 0, j = sourceIdList.length; i < j; i++) {
        this.form.ordererList.push({
          id: parseInt(sourceIdList[i]),
          name: sourceNameList[i]
        })
      }
      if (this.form.ordererList && this.form.ordererList.length > 0) {
        this.form.orderer_id = parseInt(this.form.ordererList[0].id)
        this.form.orderer = this.form.ordererList[0].name
      }
      this.add()
      if (!isModify) {
        this.queryOrderCode(this.type)
      }
      this.form.delivery_time = this.Utils.df(null, '{y}-{m}-{d} {h}:{i}:{s}')
      this.form.order_date = this.Utils.df(null, '{y}-{m}-{d} {h}:{i}:{s}')
    },
    loadForm() {
      const data = localStorage.getItem('requireOrderFormModel')
      if (data) {
        this.formModel = JSON.parse(data)
        localStorage.removeItem('requireOrderFormModel')
        if (this.formModel.id > 0) {
          this.resetForm(true)
          Object.assign(this.form, this.formModel)
          this.form.details.forEach(detail => {
            detail.selectedGoods = this.goodsMapOfId[detail.goods_id]
            detail.goodsIdsArray = this.goodsMapOfIdsArray[detail.goods_id]
            this.form.total_count += detail.count
          })
        } else {
          this.resetForm()
        }
      } else {
        this.resetForm()
      }
      this.loading = false
    },
    showDetails(row) {},
    add() {
      const newRow = Object.assign({}, this.newRowOfGoods)
      newRow.key = this.Utils.createUniqueString()
      this.form.details.push(newRow)
    },
    del(row) {
      if (this.form.details.length > 0) {
        const index = this.form.details.indexOf(row)
        if (index !== -1) {
          this.form.details.splice(index, 1)
          this.calcTotalCountAndAmount()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/require/order.vue